export const guestMobileAppCrossSellData = {
  ctaText: 'Learn More',
  eyebrowText: 'Guest Mobile App',
  titleText: 'Give your guests the deets on the go.',
  bodyText:
    'Your website comes with a companion mobile app so your guests can stay in the know and even upload photos to a shared photo gallery.',
} as const;
